<template>
  <v-autocomplete
    :label="label"
    :value="current"
    :items="candidate"
    :loading="loading"
    item-value="userId"
    item-text="userName"
    return-object
    :disabled="disabled"
    :rules="rules"
    @change="onSelected"
    clearable
    hide-no-data
    filled
    dense
    :attach="attach"
  ></v-autocomplete>
</template>

<script>
export default {
  name: "CafereoUserField",
  model: { prop: "value", event: "selected" },
  props: {
    label: { type: String, default: "担当" },
    value: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    attach: { type: Boolean, default: true },
    rules: { type: Array, default: () => [] },
    param: { type: Array, default: () => [] },
    inactivated: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: null,
      candidate: [],
      current: null,
    };
  },
  async mounted() {
    await this.setup();
    this.apply(this.value);
  },
  watch: {
    value(value) {
      this.apply(value);
    },
  },
  methods: {
    async setup() {
      try {
        this.loading = true;
        const params = { inactivated: this.inactivated };
        const response = await this.$store.dispatch("cafereoUser/search", params);
        if (response.data?.contents?.users) {
          this.candidate = response.data.contents.users;
        } else {
          this.candidate = [];
        }
      } catch (error) {
        console.error("CafereoUserField::setup", error);
      } finally {
        this.loading = false;
      }
    },
    apply(value) {
      if (value) {
        if (value == this.current?.userId) {
          // NOP
        } else {
          const current = this.candidate.find((c) => value === c.userId);
          this.onSelected(current);
        }
      } else {
        this.current = null;
      }
    },
    selected() {
      return this.current;
    },
    onSelected(value) {
      this.current = value;
      if (value) {
        this.$emit("selected", value.userId);
      } else {
        this.$emit("selected", null);
      }
    },
  },
};
</script>
